import { Component, OnInit } from '@angular/core';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { RenterForm } from '@core/components/abstract/renter-form';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-id-card',
  templateUrl: './id-card.component.html',
  styleUrls: ['./id-card.component.scss']
})
export class IdCardComponent extends RenterForm implements OnInit {

  nowDate = new Date();

  constructor(private renterFormService: RenterRegFormService) {
    super();
  }

  ngOnInit() {
  }

  get form(): FormGroup {
    try {
      return this.renterFormService.renterIdentificationDataForm.get('id_card') as FormGroup;
    } catch (e) {
      throw new Error('Renter form was not built');
    }
  }

}
